const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/forgot-password/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/forgot-password/")({
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    return {
      meta: buildPrivatePageMetaTags(tMeta("forgotPassword"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});